import ProfileForm from './ProfileForm';

export default ProfileForm;
export type { ProfileFormProps } from './ProfileForm';
